var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialDzenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_155179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1131_155179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.93 0H0.0435791V19.8864H19.93V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1131_155179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94477 19.8828H10.024C13.9725 19.8828 16.2643 19.4853 17.8878 17.9092C19.543 16.2374 19.9253 13.9301 19.9253 9.99703V9.88581C19.9253 5.95396 19.543 3.66207 17.8878 1.97361C16.2655 0.397562 13.9571 0 10.0252 0H9.94595C5.99755 0 3.70446 0.397562 2.08109 1.97361C0.42576 3.6455 0.0435791 5.95396 0.0435791 9.88581V9.99703C0.0435791 13.9289 0.42576 16.2208 2.08109 17.9092C3.68909 19.4853 5.99755 19.8828 9.94477 19.8828Z",
    fill: "url(#paint0_linear_1131_155179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5584 9.79054C17.5584 9.71482 17.4968 9.65212 17.4211 9.64857C14.7036 9.54564 13.0497 9.19901 11.8927 8.04197C10.7332 6.88257 10.3878 5.22746 10.2849 2.50405C10.2825 2.42834 10.2198 2.36682 10.1429 2.36682H9.82583C9.75012 2.36682 9.68741 2.42834 9.68387 2.50405C9.58093 5.22628 9.23548 6.88257 8.07608 8.04197C6.91787 9.20019 5.26512 9.54564 2.54763 9.64857C2.47192 9.65094 2.4104 9.71364 2.4104 9.79054V10.1076C2.4104 10.1833 2.47192 10.246 2.54763 10.2496C5.26512 10.3525 6.91904 10.6991 8.07608 11.8562C9.23311 13.0132 9.57857 14.6636 9.68269 17.3763C9.68504 17.452 9.74775 17.5136 9.82465 17.5136H10.1429C10.2186 17.5136 10.2813 17.452 10.2849 17.3763C10.389 14.6636 10.7344 13.0132 11.8915 11.8562C13.0497 10.6979 14.7024 10.3525 17.4199 10.2496C17.4956 10.2472 17.5572 10.1845 17.5572 10.1076V9.79054H17.5584Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1131_155179",
    x1: 0.0435791,
    y1: 9.94142,
    x2: 19.9253,
    y2: 9.94142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_155179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialDzenIcon);
export default __webpack_public_path__ + "static/media/SocialDzenIcon.653f08e4130125da7a003f4ee3e90ba5.svg";
export { ForwardRef as ReactComponent };